<template>
  <div class="c-empty">
    <c-character
      data-cy="c-empty-character"
      :type="character"
      class="character"
    />

    <h4 data-cy="c-empty-title" class="title">
      {{ title }}
    </h4>

    <p
      data-cy="c-empty-message"
      class="message"
      v-html="message"
    />

    <c-button
      v-if="hasButton"
      data-cy="c-empty-button"
      class="button"
      primary
      size="lg"
      icon-size="12"
      icon="chevron-right"
      :to="{ name: 'Home' }"
    >
      {{ buttonText }}
    </c-button>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    character: {
      type: String,
      required: true
    },
    hasButton: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'Ver outras ofertas'
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.c-empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 50px 0;

  & > .character {
    width: 130px;
    height: 130px;
  }

  $empty-title-font-size: 14px;
  $empty-title-font-line: 18px;
  $empty-title-font-weight: 500;
  $empty-title-font-family: $title-font-family;
  $empty-title-font-color: $base-color;

  & > .title {
    margin-top: 30px;
    margin-left: 55px;
    margin-right: 55px;
    margin-bottom: 0;
    line-height: $empty-title-font-line;
    font-size: $empty-title-font-size;
    font-weight: $empty-title-font-weight;
    font-family: $empty-title-font-family;
  }

  & > .title,
  & > .message {
    margin-top: 12px;
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0;
  }

  & > .button {
    margin-top: 45px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CEmpty.vue